import { useContext } from 'react'
import SnackbarContext, { ISnackbarContext } from '@providers/SnackbarProvider'

export default function useSnackbar() {
  const SnackbarValues = useContext<ISnackbarContext>(SnackbarContext)

  return SnackbarValues
}
